/*!
 * RedStar24 – MegaMenu Portal (body overlay) – v9
 * - Baut EIN Overlay (#rs-portal) am <body>
 * - Liest Unterkategorien aus dem versteckten Theme-Panel und rendert sie rechts
 * - Öffnet bei Hover auf Summary ODER Link („Alle Kategorien“)
 * - Schließt ruhig bei Maus raus / ESC / Outside
 */

(function(){
  'use strict';

  const MQL = matchMedia('(hover:hover) and (pointer:fine)');
  if (!MQL.matches) return;

  // Guard für andere Skripte
  window.__RS_PANE_ON__ = true;
  document.body.classList.add('rs-pane-on');

  /* ---------- Selectors ---------- */
  const TOP_SUM = 'summary.main-nav__item--toggle';
  const TOP_SUM_LINK = 'summary.main-nav__item--toggle > a, summary .main-nav__item--primary';
  const HEADER_SEL = '.shopify-section-header, .site-header, .header, header';

  const qs  = (r,s)=>r.querySelector(s);
  const qsa = (r,s)=>Array.from(r.querySelectorAll(s));

  /* ---------- Build Portal once ---------- */
  const portal = document.createElement('div');
  portal.id = 'rs-portal';
  portal.setAttribute('role','dialog');
  portal.setAttribute('aria-label','Kategorien');
  portal.hidden = true;
  portal.innerHTML = `
    <div class="rs-portal__panel" role="group" aria-label="Mega Menu">
      <div class="rs-portal__inner">
        <aside class="rs-portal__left" role="tablist" aria-orientation="vertical"></aside>
        <section class="rs-portal__right" role="tabpanel" aria-live="polite" aria-busy="false"></section>
      </div>
    </div>`;
  document.body.appendChild(portal);

  const left  = qs(portal, '.rs-portal__left');
  const right = qs(portal, '.rs-portal__right');
  const panelEl = qs(portal, '.rs-portal__panel');

  let cache = []; // [{label, htmlFragment}]
  let closeTimer = null;

  /* ---------- Utils ---------- */

  function headerBottom(){
    const hdr = document.querySelector(HEADER_SEL);
    const rect = hdr ? hdr.getBoundingClientRect() : {bottom:0};
    return Math.max(0, Math.round(rect.bottom));
  }
  function setPortalTop(){
    const t = headerBottom();
    document.documentElement.style.setProperty('--rs-top', t + 'px');
  }

  function cancelClose(){ if (closeTimer){ clearTimeout(closeTimer); closeTimer=null; } }
  function scheduleClose(){
    cancelClose();
    closeTimer = setTimeout(closePortal, 220);
  }

  function openPortal(){
    setPortalTop();
    portal.hidden = false;
    portal.classList.add('rs-open');
    document.body.classList.add('rs-menu-open'); // für evtl. Styling an anderer Stelle
  }
  function closePortal(){
    portal.classList.remove('rs-open');
    portal.hidden = true;
    document.body.classList.remove('rs-menu-open');
  }

  function clearRight(){
    right.classList.remove('is-ready');
    right.innerHTML = '';
  }
  function showRight(htmlFrag){
    right.setAttribute('aria-busy','true');
    clearRight();
    const host = document.createElement('div');
    host.setAttribute('data-rs-pane','');
    host.appendChild(htmlFrag.cloneNode(true));
    right.appendChild(host);
    // kleine Verzögerung für CSS-Transition
    requestAnimationFrame(()=> right.classList.add('is-ready'));
    right.setAttribute('aria-busy','false');
  }

  /* ---------- Read source menu once ---------- */
  function readSource(){
    cache = [];
    left.innerHTML = '';

    // Finde das Top-<details> samt verstecktem Panel (.main-nav__child)
    const topSummary = document.querySelector(TOP_SUM);
    if (!topSummary) return false;
    const topDetails = topSummary.closest('details');
    if (!topDetails) return false;

    const panelHost = Array.from(topDetails.children).find(el => el.tagName !== 'SUMMARY');
    if (!panelHost) return false;

    // Sammle alle Sub-<details> im Panel, die ein .disclosure__panel besitzen
    const subs = qsa(panelHost, 'details').filter(d => qs(d, ':scope > .disclosure__panel'));
    if (!subs.length) return false;

    subs.forEach((d, i) => {
      const label = (qs(d, ':scope > summary a')?.textContent
                  || qs(d, ':scope > summary')?.textContent
                  || 'Kategorie').trim();

      // Inhalt klonen: <div class="disclosure__panel"> … -> UL
      const panel = qs(d, ':scope > .disclosure__panel');
      const frag = document.createDocumentFragment();
      // wir übernehmen nur das UL/den ersten Block
      const first = panel.querySelector('ul, .main-nav__grandchild, *');
      if (first) frag.appendChild(first.cloneNode(true));

      cache.push({ label, frag });

      // Linke Liste (Buttons)
      const btn = document.createElement('button');
      btn.className = 'rs-left__item';
      btn.type = 'button';
      btn.setAttribute('role','tab');
      btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      btn.dataset.index = String(i);
      btn.textContent = label;
      btn.addEventListener('mouseenter', () => activate(i), { passive: true });
      btn.addEventListener('focus', () => activate(i), { passive: true });
      left.appendChild(btn);
    });

    // Erste Pane zeigen
    if (cache.length) {
      showRight(cache[0].frag);
    }

    return true;
  }

  function activate(i){
    const items = qsa(left, '.rs-left__item');
    items.forEach((b,idx)=> b.setAttribute('aria-selected', idx===i ? 'true' : 'false'));
    const entry = cache[i];
    if (entry) showRight(entry.frag);
  }

  /* ---------- Event binding ---------- */

  // Öffnen bei Hover auf Summary ODER den Link im Summary
  function maybeOpenFromTrigger(target){
    const trg = target.closest(TOP_SUM + ', ' + TOP_SUM_LINK);
    if (!trg) return;
    // Erstaufbau?
    if (!cache.length){ 
      const ok = readSource();
      if (!ok) return;
    }
    openPortal();
  }

  document.addEventListener('pointerenter', (e)=>{
    maybeOpenFromTrigger(e.target);
  }, {capture:true, passive:true});
  document.addEventListener('pointerover', (e)=>{
    maybeOpenFromTrigger(e.target);
  }, {capture:true, passive:true});

  // Keep-Alive innerhalb Portal oder Header
  const header = document.querySelector(HEADER_SEL) || document.body;
  header.addEventListener('pointerenter', cancelClose, {passive:true});
  header.addEventListener('pointerleave', scheduleClose, {passive:true});
  portal.addEventListener('pointerenter', cancelClose, {passive:true});
  portal.addEventListener('pointerleave', scheduleClose, {passive:true});

  // Schließen außerhalb / ESC
  document.addEventListener('keydown', e=>{ if (e.key==='Escape') closePortal(); });
  document.addEventListener('pointerdown', e=>{
    if (!portal.hidden && !portal.contains(e.target) && !header.contains(e.target)){
      closePortal();
    }
  }, {capture:true});

  // Reposition bei Resize/Scroll
  const onReflow = ()=>{ if (!portal.hidden) setPortalTop(); };
  window.addEventListener('resize', onReflow, {passive:true});
  window.addEventListener('scroll', onReflow, {passive:true});

})();
